module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homepage company-landing"
  }, [(_vm.disableAPI) ? _c('div', {
    staticClass: "loading-data-wrapper"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.heroSection.hideSection || _vm.content.heroSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper hero-section"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.hideSection),
      expression: "content.heroSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHero"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.heroSection.hideSection) ? _vm._i(_vm.content.heroSection.hideSection, null) > -1 : (_vm.content.heroSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.heroSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.heroSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'showHero'
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('div', {
    staticClass: "hero-title"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "content color-2-100",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "content color-2-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-description"
  }, [(!_vm.pageEditMode) ? _c('p', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.heroSection.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.description),
      expression: "content.heroSection.description"
    }],
    staticClass: "content",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.description))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-register"
  }, [_c('div', {
    staticClass: "hero-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-wrapper"
  }, [_c('div', {
    staticClass: "tcc-form"
  }), _vm._v(" "), _c('form', {
    staticClass: "tcc-form",
    on: {
      "submit": function($event) {
        return _vm.submitCallbackRequest()
      }
    }
  }, [_c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-name"
    }
  }, [_vm._v("First name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.name),
      expression: "registerForm.name"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.name !== '' || _vm.registerForm.nameFocus,
      'not-empty': _vm.registerForm.name !== '' || _vm.registerForm.nameFocus,
      'has-error': _vm.errors.has('First name')
    }],
    attrs: {
      "id": "register-name",
      "data-lpignore": "true",
      "type": "text",
      "name": "First name",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.name)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.nameFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.nameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-surname"
    }
  }, [_vm._v("Last name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.surname),
      expression: "registerForm.surname"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.surname !== '' || _vm.registerForm.surnameFocus,
      'not-empty': _vm.registerForm.surname !== '' || _vm.registerForm.surnameFocus,
      'has-error': _vm.errors.has('Last name')
    }],
    attrs: {
      "id": "register-surname",
      "data-lpignore": "true",
      "type": "text",
      "name": "Last name",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.surname)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.surnameFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.surnameFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "surname", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-phone"
    }
  }, [_vm._v("Contact number*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.phone),
      expression: "registerForm.phone"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.phone !== '' || _vm.registerForm.phoneFocus,
      'not-empty': _vm.registerForm.phone !== '' || _vm.registerForm.phoneFocus,
      'has-error': _vm.errors.has('Contact number')
    }],
    attrs: {
      "id": "register-phone",
      "data-lpignore": "true",
      "type": "text",
      "name": "Contact number",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.phone)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.phoneFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.phoneFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Contact number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Contact number')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-email"
    }
  }, [_vm._v("Email address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.email),
      expression: "registerForm.email"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.email !== '' || _vm.registerForm.emailFocus,
      'not-empty': _vm.registerForm.email !== '' || _vm.registerForm.emailFocus,
      'has-error': _vm.errors.has('Email address')
    }],
    attrs: {
      "id": "register-email",
      "data-lpignore": "true",
      "type": "email",
      "name": "Email address",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.email)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email address')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email address')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-subject"
    }
  }, [_vm._v("Subject (Short but descriptive)*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.subject),
      expression: "registerForm.subject"
    }],
    staticClass: "tcc-form-element tcc-form-element__input",
    class: [{
      'border-1-20': _vm.registerForm.subject !== '' || _vm.registerForm.subjectFocus,
      'not-empty': _vm.registerForm.subject !== '' || _vm.registerForm.subjectFocus,
      'has-error': _vm.errors.has('Subject')
    }],
    attrs: {
      "id": "register-subject",
      "data-lpignore": "true",
      "type": "text",
      "name": "Subject",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.subject)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.subjectFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.subjectFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "subject", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Subject')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Subject')))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "callback-request-message-info",
    attrs: {
      "id": "messageDescription"
    }
  }, [_vm._v("\n                  Tell us about the difficulties that you encountered with Clear Assured and we’ll contact you with a solution shortly.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('label', {
    attrs: {
      "for": "register-message"
    }
  }, [_vm._v("Description (Please be as descriptive as possible)*")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.message),
      expression: "registerForm.message"
    }],
    staticClass: "tcc-form-element tcc-form-element__textarea",
    class: [{
      'border-1-20': _vm.registerForm.message !== '' || _vm.registerForm.messageFocus,
      'not-empty': _vm.registerForm.message !== '' || _vm.registerForm.messageFocus,
      'has-error': _vm.errors.has('Your message')
    }],
    attrs: {
      "id": "register-message",
      "data-lpignore": "true",
      "type": "text",
      "name": "Your message",
      "aria-describedby": "messageDescription",
      "placeholder": "Type in here..."
    },
    domProps: {
      "value": (_vm.registerForm.message)
    },
    on: {
      "focus": function($event) {
        _vm.registerForm.messageFocus = true
      },
      "blur": function($event) {
        _vm.registerForm.messageFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registerForm, "message", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Your message')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Your message')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-register-terms"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.registerForm.privacy),
      expression: "registerForm.privacy"
    }],
    staticClass: "tcc-form-element tcc-form-element__checkbox",
    class: [{
      'has-error': _vm.errors.has('Privacy policy')
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "register-privacy",
      "name": "Privacy policy"
    },
    domProps: {
      "checked": Array.isArray(_vm.registerForm.privacy) ? _vm._i(_vm.registerForm.privacy, null) > -1 : (_vm.registerForm.privacy)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.registerForm.privacy,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.registerForm, "privacy", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.registerForm, "privacy", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.registerForm, "privacy", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "register-privacy"
    }
  }, [_vm._v("Agree to the Clear Assured "), _c('router-link', {
    attrs: {
      "to": "/privacy-policy"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v("*.")], 1), _vm._v(" "), (this.errors.has('Privacy policy')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Privacy policy')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-actions"
  }, [_c('button', {
    staticClass: "tcc-form-action",
    class: [{
      'submitting': _vm.registerForm.requestInProgress
    }],
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitCallbackRequest()
      }
    }
  }, [_vm._v("\n                    Submit help request\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-message",
    attrs: {
      "aria-live": "assertive"
    }
  }, [(this.formStatus.submitting) ? _c('div', {
    staticClass: "visually-hidden"
  }, [_vm._v("\n                    Submitting\n                  ")]) : [(_vm.formStatus.shown) ? [(_vm.formStatus.title !== '') ? _c('h2', [(_vm.formStatus.success) ? [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-check",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-check",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"
    }
  })])] : [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
    }
  })])], _vm._v("\n                        " + _vm._s(_vm.formStatus.title) + "\n                      ")], 2) : _vm._e(), _vm._v(" "), (_vm.formStatus.body !== '') ? _c('p', [_vm._v("\n                        " + _vm._s(_vm.formStatus.body) + "\n                      ")]) : _vm._e()] : (this.errors.items && this.errors.items.length) ? [_c('h2', [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-exclamation",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-exclamation",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
    }
  })]), _vm._v("\n                        Some fields are missing.\n                      ")]), _vm._v(" "), _c('p', [_vm._v("Please fill in all the mandatory fields - they are marked with an asterisk. You should also see them in red and with a warning message showing under each field.")])] : _vm._e()]], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "hero-image"
  }, [_c('div', {
    staticClass: "content",
    style: ({
      backgroundImage: _vm.getImage(_vm.content.heroSection.image)
    }),
    attrs: {
      "title": _vm.content.heroSection.altImage
    }
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.altImage),
      expression: "content.heroSection.altImage"
    }],
    staticClass: "landing-page-image-alt",
    attrs: {
      "type": "text",
      "placeholder": "Alt image"
    },
    domProps: {
      "value": (_vm.content.heroSection.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "altImage", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
    staticClass: "hero-upload",
    attrs: {
      "for": 'hero-image-upload'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    attrs: {
      "type": "file",
      "id": 'hero-image-upload'
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.content.heroSection, 'image')
      }
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-data"
  }, [_c('div'), _c('div'), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Fields marked with an asterisk ("), _c('span', [_vm._v("*")]), _vm._v(") are mandatory.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-606315aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/subscriptions/NeedHelpRequest.vue
// module id = 1009
// module chunks = 0